<template>
    <df-await>
        <div class="user-display coach" v-if="data">
            <div class="user-display-bg">
                <img :src="data.backgroundPath" alt="Profile Background" width="426" height="121" v-if="data.backgroundPath">
                <img src="../../assets/images/coach--heidiland.png" alt="Profile Background" width="426" height="121" v-else-if="isHeidilandSystem">
                <img src="../../assets/images/coach.svg" alt="Profile Background" width="426" height="121" v-else>
            </div>
            <div class="user-display-bottom">
                <div class="user-display-avatar"><avatar :username="`${data.firstname} ${data.lastname}`" :src="data.avatarBig" :size="110"/></div>
                <div class="user-display-info user-display-details d-flex flex-wrap justify-content-between">
                    <div>
                        <div class="name">{{data.firstname}} {{data.lastname}}</div>
                        <div class="nick"><span class="mdi mdi-email"></span>&nbsp;<a :href="`mailto:${data.email}`">{{data.email}}</a></div>
                    </div>
                    <!--
                    <div>
                        <div class="title">Kundenbewertung</div>
                        <df-rating class="counter" :rating="data.rating"/>
                    </div>
                    -->
                </div>
                <div class="user-info-list" v-if="!short">
                    <table class="no-border no-strip skills">
                        <tbody class="no-border-x no-border-y">
                        <tr>
                            <td class="icon"><span class="mdi mdi-pin"></span></td>
                            <td class="item">Region</td>
                            <td>{{ data.region }}</td>
                        </tr>
                        <tr>
                            <td class="icon"><span class="mdi mdi-globe-alt"></span></td>
                            <td class="item">Sprachen</td>
                            <td>{{ languages }}</td>
                        </tr>
                        <!--
                        <tr>
                            <td class="icon"><span class="mdi mdi-graduation-cap"></span></td>
                            <td class="item">Erfasste Solutions</td>
                            <td>{{ data.solutions }}</td>
                        </tr>
                        -->
                        <!--
                        <tr>
                            <td class="icon"><span class="mdi mdi-assignment-alert"></span></td>
                            <td class="item">Durchgeführte<br>Assessments</td>
                            <td>{{ data.assessments }}</td>
                        </tr>
                        -->
                        <tr v-if="data.specialization">
                            <td class="icon"><span class="mdi mdi-star-circle"></span></td>
                            <td class="item">Spezialisierung</td>
                            <td>{{ data.specialization.join(', ') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <slot/>
        </div>
    </df-await>
</template>

<script>
    import env from '../../mixins/env';

    import User from '../../models/User';
    import Coach from '../../models/Coach';

    import DfRating from './DfRating';

    export default {
        mixins: [env],
        components: { DfRating },

        props: {
            data: [User, Coach],
            short: Boolean,
        },

        computed: {
            languages() {
                return this.data.languages.map(k => User.LanguagesMap[k]).join(', ');
            },
        },
    };
</script>
